import { render, staticRenderFns } from "./PropertyAddDialog.vue?vue&type=template&id=88a97bbe"
import script from "./PropertyAddDialog.vue?vue&type=script&lang=ts"
export * from "./PropertyAddDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports